module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "half-half border-top"
  }, [_c('div', {
    class: {
      'half-half': _vm.$parent.individual_days, 'full-width': _vm.$parent.individual_days
    }
  }, [(!_vm.$parent.individual_days) ? _c('div', {
    class: {
      'right': !_vm.$parent.individual_days
    }
  }, [(!this.$root.auth || !this.$root.auth.user_id) ? _c('div', {
    staticClass: "content-block hidden-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.$parent.locale.text_participant_description)
    }
  }) : _vm._e(), _vm._v(" "), (!this.$root.auth || !this.$root.auth.user_id) ? _c('router-link', {
    staticClass: "cta-button red hidden-xs",
    attrs: {
      "to": {
        name: 'auth.login',
        query: {
          back: _vm.$route.fullPath
        }
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.locale.global.button_login)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.participants.length > 0) ? _c('div', {
    staticClass: "box-layout-inner existing-participants"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "half-half blue",
    attrs: {
      "id": "existingParticipants"
    }
  }, _vm._l((_vm.participants), function(participant, key) {
    return _c('div', {
      class: {
        disabled: !_vm.isAvailable(participant.dob, participant)
      }
    }, [_c('existing-participant', {
      attrs: {
        "selection": _vm.selection,
        "participant": participant,
        "available": _vm.isAvailable(participant.dob, participant)
      },
      on: {
        "addchosen": _vm.addParticipant,
        "removechosen": _vm.removeParticipant
      }
    })], 1)
  }))])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$parent.individual_days) ? _c('div', {
    class: {
      'left': !_vm.$parent.individual_days
    }
  }, [(!this.$root.auth || !this.$root.auth.user_id) ? _c('div', {
    staticClass: "content-block hidden-sm hidden-md hidden-lg",
    domProps: {
      "innerHTML": _vm._s(_vm.$parent.locale.text_participant_description)
    }
  }) : _vm._e(), _vm._v(" "), (!this.$root.auth || !this.$root.auth.user_id) ? _c('router-link', {
    staticClass: "cta-button red hidden-sm hidden-md hidden-lg",
    attrs: {
      "to": {
        name: 'auth.login',
        query: {
          back: _vm.$route.fullPath
        }
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.locale.global.button_login)
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    key: 0,
    staticClass: "box-layout-inner alert"
  }, [_c('div', {
    staticClass: "full-width green"
  }, [_c('span', [_vm._v("Participant has been successfully added.")])])])]), _vm._v(" "), _c('new-participant', {
    key: 1,
    on: {
      "newparticipant": _vm.newParticipant
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [(!this.$root.auth || !this.$root.auth.user_id) ? _c('div', {
    staticClass: "content-block",
    domProps: {
      "innerHTML": _vm._s(_vm.$parent.locale.text_participant_description)
    }
  }) : _vm._e(), _vm._v(" "), (!this.$root.auth || !this.$root.auth.user_id) ? _c('router-link', {
    staticClass: "cta-button red",
    attrs: {
      "to": {
        name: 'auth.login',
        query: {
          back: _vm.$route.fullPath
        }
      }
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$root.locale.global.button_login)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.participants.length > 0) ? _c('div', {
    staticClass: "box-layout-inner existing-participants"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "half-half blue",
    attrs: {
      "id": "existingParticipants"
    }
  }, _vm._l((_vm.participants), function(participant, key) {
    return _c('div', {
      class: {
        disabled: !_vm.isAvailable(participant.dob)
      }
    }, [_c('existing-participant', {
      attrs: {
        "selection": _vm.selection,
        "participant": participant,
        "available": _vm.isAvailable(participant.dob, participant)
      },
      on: {
        "addchosen": _vm.addParticipant,
        "removechosen": _vm.removeParticipant
      }
    })], 1)
  }))])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    key: 0,
    staticClass: "box-layout-inner alert"
  }, [_c('div', {
    staticClass: "full-width green"
  }, [_c('span', [_vm._v("Participant has been successfully added.")])])])]), _vm._v(" "), _c('new-participant', {
    key: 1,
    on: {
      "newparticipant": _vm.newParticipant
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e162ef36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/PackageOptions/WhosAttending.vue
// module id = 193
// module chunks = 0